import { navigate } from "gatsby";

export const navigateWithParamsForFiltering = (
  params: Record<string, string | undefined>
) => {
  const queryString = Object.entries(params)
    .filter(([_, v]) => Boolean(v))
    .map(([k, v]) => `${k}=${encodeURIComponent(v!)}`)
    .join("&");
  navigate(`${queryString ? `?${queryString}` : ""}`, {
    replace: true
  });
};

export interface NavigateOptions<TState> {
    state?: TState | undefined;
    replace?: boolean | undefined;
}

export const navigateWithUrlSearchParams = (params: URLSearchParams, opts: NavigateOptions<{}> = { replace: true }) => {
  navigate(`?${params.toString()}`, opts);
};
